import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FavouriteItemFacade } from './+state';
import { FavouriteItemStateModule } from './+state/favourite-item.state.module';

import {
  FavouriteItemService
} from './services';

@NgModule({
  imports: [CommonModule, FavouriteItemStateModule],
})
export class DomainFavouriteItemModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainFavouriteItemModule,
      providers: [
        FavouriteItemService,
        FavouriteItemFacade
      ],
    };
  }
}
